module.exports = __webpack_public_path__ + "img/LOGO_1603_1_2.0dffd89d.svg";